// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../assets/fonts/Nunito/Nunito.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Case_360_view {
  font-size: 12px !important;
}

.eventselecttypeControl {
  width: 96%;
  border: none;
  padding-block: 2px;
  height: 28px;
  margin-left: 2%;
  padding-right: 23px !important;
}

.blod_text {
  color: #007887;
}

.date_control_style {
  width: 30%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 2%;
}

.close_icon {
  position: absolute;
  top: 27%;
  font-size: 16px;
  cursor: pointer;
  color: grey;
  font-weight: 600;
  right: 0;
}

.help-main-title {
  font-size: 17px;
  text-align: center;
}

.case_details {
  flex: auto;
  text-align: center;
  position: relative;
}

.caseHeaderBorder {
  height: 14px;
  width: 2px;
  background-color: #17a0b4 !important;
  position: absolute;
  top: 14%;
  right: 0%;
}

.case_info {
  background: #e2e2e2 0% 0% no-repeat padding-box;
  padding-inline: 8px;
}

.messageList_view {
  height: 66vh;
  overflow-x: hidden;
  font-size: 11px;
}

::ng-deep.message_screen_case {
  font-family: montserrat !important;
  overflow: hidden;
}
::ng-deep.message_screen_case .mat-tab-header {
  height: 29;
}
::ng-deep.message_screen_case .mat-tab-label {
  height: 31px !important;
  text-transform: uppercase;
}
::ng-deep.message_screen_case .mat-tab-group.mat-primary .mat-ink-bar,
::ng-deep.message_screen_case .mat-tab-nav-bar.mat-primary .mat-ink-bar {
  margin-left: unset !important;
}
::ng-deep.message_screen_case .mat-tab-label-container {
  background-color: transparent;
  border-bottom: 1px solid #17a0b4;
}
::ng-deep.message_screen_case .mat-tab-group.mat-primary .mat-ink-bar {
  background-color: #376B96 !important;
  height: 2px !important;
}
::ng-deep.message_screen_case .mat-tab-label .mat-tab-label-content {
  font-size: 11px !important;
  font-weight: 600 !important;
  font-family: montserrat !important;
}
::ng-deep.message_screen_case .mat-tab-label.mat-ripple.mat-tab-label-active {
  color: #376B96 !important;
  background-color: white !important;
  opacity: unset !important;
}

.active_img {
  display: none;
}

.inactive_img {
  display: block;
  margin-right: 9px;
  position: relative;
  top: -2px;
}

.active_img_inbound {
  display: none;
}

.inactive_img_inbound {
  display: block;
  margin-right: 11px;
  position: relative;
  top: -2px;
}

::ng-deep.event_card {
  height: 73vh;
  border-right: 3px solid #007887;
}
::ng-deep.event_card .header {
  height: 40px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
}
::ng-deep.event_card .header .search_control {
  width: 90%;
  height: 25px;
  margin: auto;
  border-radius: 5px;
  border: 1px solid #001c3b;
  background-color: white;
}
::ng-deep.event_card .header .search_control .search_icon {
  position: relative;
  left: 2%;
  top: 10%;
}
::ng-deep.event_card .header .search_control .input_control {
  width: 93%;
  border: none;
  background-color: transparent;
  position: relative;
  left: 3%;
  top: 13%;
}
::ng-deep.event_card .mat-tab-label {
  height: 29px !important;
  flex: 1 !important;
  text-transform: uppercase;
}
::ng-deep.event_card .mat-tab-group.mat-primary .mat-ink-bar,
::ng-deep.event_card .mat-tab-nav-bar.mat-primary .mat-ink-bar {
  margin-left: unset !important;
}
::ng-deep.event_card .mat-tab-label-container {
  background-color: #f3f3f3 !important;
}
::ng-deep.event_card .mat-tab-group.mat-primary .mat-ink-bar {
  background-color: #376B96 !important;
  height: 3px !important;
}
::ng-deep.event_card .mat-tab-label .mat-tab-label-content {
  font-size: 10px !important;
  font-weight: 600 !important;
  font-family: montserrat !important;
}
::ng-deep.event_card .mat-tab-label.mat-ripple.mat-tab-label-active {
  color: #376B96 !important;
  background-color: white !important;
  opacity: unset !important;
}
::ng-deep.event_card .mat-tab-label.mat-ripple.mat-tab-label-active .outbound_style .active_img {
  display: block !important;
  margin-right: 9px;
  position: relative;
  top: -2px;
}
::ng-deep.event_card .mat-tab-label.mat-ripple.mat-tab-label-active .outbound_style .inactive_img {
  display: none !important;
}
::ng-deep.event_card .mat-tab-label.mat-ripple.mat-tab-label-active .inbound_style .active_img_inbound {
  display: block !important;
  margin-right: 11px;
  position: relative;
  top: -2px;
}
::ng-deep.event_card .mat-tab-label.mat-ripple.mat-tab-label-active .inbound_style .inactive_img_inbound {
  display: none !important;
}

.event_card_info {
  height: 73vh;
  border-left: 3px solid #007887;
  margin-left: 2px;
}
.event_card_info .header {
  height: 40px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
}

.Event_lables {
  max-height: 60px;
  background: #e5f1f3;
  padding-inline: 13px;
  overflow-x: hidden;
  min-height: 33px;
  font-family: montserrat !important;
}

.eventtype_lables {
  background-color: white;
  padding-inline: 4%;
  padding-block: 0px;
  margin: 6px;
  display: inline-block;
  border-radius: 50pc;
  cursor: pointer;
  box-shadow: 1px 1px 4px 0px grey;
  font-size: 11px;
}

.eventtype_lables_active {
  background-color: #007887;
  padding-inline: 4%;
  padding-block: 0px;
  margin: 6px;
  display: inline-block;
  border-radius: 50pc;
  cursor: pointer;
  color: white;
  box-shadow: 1px 1px 4px 0px grey;
  font-size: 11px;
}

.messageInfo {
  box-shadow: 1px 1px 6px 0px grey;
  border-radius: 5px;
  padding-inline: 6px;
  padding-block: 3px;
}

.cardActive {
  background-color: #cce4e7;
}

.listview {
  padding-inline: 19px;
  max-height: 53vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: montserrat !important;
  font-size: 11px;
}

.view_file_icon {
  width: 19px !important;
  position: relative;
  top: 6px;
  left: 6px;
}

.barline {
  height: 1px;
  background-color: black;
  margin-inline: 13px;
}

::ng-deep.message_menu.mat-menu-panel button.mat-menu-item {
  height: 26px !important;
  line-height: 26px !important;
  text-align: center !important;
  color: #179fb3 !important;
  font-size: 13px !important;
}

.lables_status {
  border-radius: 4px;
  padding-block: 3px;
  font-size: 10px;
  font-weight: 600;
}

::ng-deep.viewstages .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.viewstages {
  top: 4% !important;
}

.inputContainer {
  height: 60vh;
  background-color: #f3f3f3;
  border: 1px solid #707070;
}
.inputContainer .header {
  background-color: #d1d1d1;
  font-size: 12px;
  font-weight: 500;
  border-bottom: 1px solid #707070;
}

.outputContainer {
  height: 60vh;
  background-color: #f3f3f3;
  border: 1px solid #707070;
}
.outputContainer .header {
  background-color: #d1d1d1;
  font-size: 12px;
  font-weight: 500;
  border-bottom: 1px solid #707070;
}

.icons_list_style {
  width: 5%;
  padding-bottom: 1px;
  text-align: center;
  margin-inline: 3px;
  height: 35px;
}

.icons_list_style_active {
  border-bottom: 3px solid #00bcd4;
  width: 5%;
  padding-bottom: 1px;
  text-align: center;
  margin-inline: 3px;
  height: 35px;
  position: relative;
}

.case_info_container {
  border: 1.5px solid #17a0b4;
  padding: 5px;
  position: relative;
  margin-block: 16px;
}

.card_label_title {
  background-color: #fbfbfb;
  position: absolute;
  padding-inline: 5px;
  font-size: 11px;
  top: -10px;
  color: #17a0b4;
  font-weight: 600;
}

.active_card {
  background-color: #07a36e;
  color: white;
}

.created_card {
  background-color: #ffc107;
  color: white;
}

.failed_card {
  background-color: #da606c;
  color: white;
}

.healing_card {
  background-color: #f5a700;
  color: white;
}

.ignore_card {
  background-color: rgba(128, 128, 128, 0.6901960784);
  color: rgba(8, 8, 8, 0.897);
}

.active_card_bor {
  border-left: 4px solid #07a36e;
}

.created_card_bor {
  border-left: 4px solid #ffc107;
}

.inprogress_card {
  background-color: #ff8900;
  color: white;
}

.inprogress_card_bor {
  border-left: 4px solid #ff8900;
}

.hold_card_bor {
  border-left: 4px solid #007bff;
}

.hold_card {
  background-color: #007bff;
  color: white;
}

.failed_card_bor {
  border-left: 4px solid #da606c;
}

.healing_card_bor {
  border-left: 4px solid #f5a700;
}

.ignore_card_bor {
  border-left: 4px solid rgba(128, 128, 128, 0.6901960784);
}

.input_data_control {
  width: 100%;
  height: 54vh;
  overflow-x: hidden;
  padding-inline: 12px;
  padding-block: 3px;
  word-break: break-word;
}

.acknowledge {
  font-size: 25px;
  position: relative;
  top: -1px;
}

.transform {
  font-size: 27px;
  position: relative;
  top: -5px;
}

.copy_icon {
  margin-left: 2%;
  cursor: pointer;
  font-size: 15px;
}

::ng-deep.viewstages {
  top: 4% !important;
  font-family: montserrat;
  font-size: 11px;
}
::ng-deep.viewstages strong {
  font-weight: 600 !important;
}

::ng-deep.viewfiles {
  top: 4% !important;
  font-family: montserrat;
  font-size: 11px;
}
::ng-deep.viewfiles strong {
  font-weight: 600 !important;
}

::ng-deep.messageioteditor .editor-container {
  overflow: hidden !important;
  position: relative !important;
  display: table !important;
  width: 100% !important;
  height: 99% !important;
  min-width: 0 !important;
}

::ng-deep.messageiot .modal-dialog .modal-content .modal-footer {
  display: unset !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  justify-content: flex-end !important;
  border-top: 1px solid #dee2e6 !important;
  border-bottom-right-radius: calc(0.3rem - 1px) !important;
  border-bottom-left-radius: calc(0.3rem - 1px) !important;
}

.stages_cards {
  height: 80vh;
}

::ng-deep.viewfiles .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.viewfiles {
  top: 4% !important;
}

.text_elip {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}

.example-container {
  height: 200px;
  min-height: 550px;
  overflow: auto;
  position: relative;
  display: flex;
  justify-content: center;
  margin: auto;
}

.app-table-wrapper {
  overflow-x: scroll;
  font-family: montserrat;
  margin: 20px;
  box-shadow: 0px 0px 5px -1px grey;
}

.app-table {
  font-size: 8px;
  font-family: montserrat;
}

#app-table {
  font-family: montserrat !important;
}

.mat-cell {
  padding: 6px;
  border-right: 1px solid lightgrey;
  text-align: center;
  min-width: 100px;
  font-size: 12px;
  background-color: white !important;
}

.mat-table-sticky-border-elem-right {
  border-left: 1px solid #e0e0e0;
}

.mat-table-sticky-border-elem-left {
  border-right: 1px solid #e0e0e0;
}

.mat-header-cell {
  padding: 2px;
  border-right: 1px solid lightgrey;
  text-align: center;
}

td.mat-cell:first-of-type {
  padding-left: 0px !important;
}

/*
.mat-column-name {
  width: 110px;
}
.mat-column-position {
  width: 80px;
  left: 110px !important;
}
*/
.text_green {
  color: #30cd30 !important;
}

.mismatch {
  background-color: rgba(255, 182, 182, 0.5490196078) !important;
}

.view-btn-details {
  position: absolute;
  left: 57%;
  width: 84px;
}

::ng-deep.Mode_Boot .modal-dialog {
  max-width: 97% !important;
  max-height: 100% !important;
  height: 100% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.Mode_Boot {
  top: 3% !important;
  font-family: montserrat;
  font-size: 12px;
}
::ng-deep.Mode_Boot strong {
  font-weight: 600 !important;
}

.interfacehvr:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white;
  padding: 3px;
  cursor: pointer;
}

.hl7-btn {
  background-color: #17a0b4;
  color: white;
  display: inline-flex; /* flexbox for alignment */
  align-items: center; /* vertical centering */ /* adjust padding for compact size */
  cursor: pointer;
  width: 90px;
  height: 24px;
}

.hl7-btn:hover {
  background-color: #138b9a;
}

.hl7-icon {
  font-size: 18px;
  position: relative;
  left: 2px;
  margin-right: 4px;
  padding: 3px 8px 6px 3px; /* size balanced with text */
}

.copylabel {
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
}

::ng-deep.messageiotcase360 .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.viewstagescasemsg360 .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.Mode_Bootcase360 .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.myCustomModalClasscase360 .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.myCustomModalClasscase360hl7 .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.messageiotcase360 {
  font-family: montserrat;
  font-size: 11px;
}
::ng-deep.messageiotcase360 strong {
  font-weight: 600 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/case360/casemessage/casemessage.component.scss"],"names":[],"mappings":"AAGA;EACE,0BAAA;AADF;;AAIA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;AADF;;AAGA;EACE,cAAA;AAAF;;AAEA;EACE,UAAA;EACA,+GAAA;EAEA,kBAAA;EACA,kBAAA;AAAF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;AACF;;AACA;EACE,eAAA;EACA,kBAAA;AAEF;;AAAA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;AAGF;;AACA;EACE,YAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAEF;;AAAA;EACE,+CAAA;EACA,mBAAA;AAGF;;AAAA;EACE,YAAA;EAAa,kBAAA;EACb,eAAA;AAIF;;AAFA;EACE,kCAAA;EAEA,gBAAA;AAIF;AAHE;EACE,UAAA;AAKJ;AAHE;EACE,uBAAA;EACA,yBAAA;AAKJ;AAHE;;EAIE,6BAAA;AAGJ;AAAE;EACE,6BAAA;EACA,gCAAA;AAEJ;AAAE;EACE,oCAAA;EACA,sBAAA;AAEJ;AAAE;EACE,0BAAA;EACA,2BAAA;EACA,kCAAA;AAEJ;AACE;EACE,yBAAA;EACA,kCAAA;EACA,yBAAA;AACJ;;AAGA;EACE,aAAA;AAAF;;AAEA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AACF;;AACA;EACE,aAAA;AAEF;;AAAA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAGF;;AADA;EACE,YAAA;EACA,+BAAA;AAIF;AAHE;EACE,YAAA;EACA,+CAAA;AAKJ;AAJI;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AAMN;AALM;EACE,kBAAA;EACA,QAAA;EACA,QAAA;AAOR;AALM;EACE,UAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;AAOR;AAFE;EACE,uBAAA;EACA,kBAAA;EACA,yBAAA;AAIJ;AAFE;;EAIE,6BAAA;AAEJ;AACE;EACE,oCAAA;AACJ;AACE;EACE,oCAAA;EACA,sBAAA;AACJ;AACE;EACE,0BAAA;EACA,2BAAA;EACA,kCAAA;AACJ;AAEE;EACE,yBAAA;EACA,kCAAA;EACA,yBAAA;AAAJ;AAEM;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AAAR;AAEM;EACE,wBAAA;AAAR;AAIM;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAFR;AAIM;EACE,wBAAA;AAFR;;AAOA;EACE,YAAA;EACA,8BAAA;EACA,gBAAA;AAJF;AAKE;EACE,YAAA;EACA,+CAAA;AAHJ;;AAMA;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;AAHF;;AAKA;EACE,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;AAFF;;AAKA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;AAFF;;AAaA;EAEE,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAXF;;AAcA;EACE,yBAAA;AAXF;;AAcA;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,eAAA;AAXF;;AAcA;EACE,sBAAA;EAEA,kBAAA;EACA,QAAA;EACA,SAAA;AAZF;;AAeA;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;AAZF;;AAgBE;EACE,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,0BAAA;AAbJ;;AAiBA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAdF;;AAgBA;EACE,kBAAA;AAbF;;AAgBA;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;AAbF;AAcE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAZJ;;AAeA;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;AAZF;AAaE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAXJ;;AAeA;EACE,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAZF;;AAcA;EACE,gCAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAXF;;AAcA;EACE,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAXF;;AAcA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;AAXF;;AAcA;EACE,yBAAA;EACA,YAAA;AAXF;;AAaA;EACE,yBAAA;EACA,YAAA;AAVF;;AAaA;EACE,yBAAA;EACA,YAAA;AAVF;;AAYA;EACE,yBAAA;EACA,YAAA;AATF;;AAYA;EACE,mDAAA;EACA,2BAAA;AATF;;AAYA;EACE,8BAAA;AATF;;AAWA;EACE,8BAAA;AARF;;AAUA;EACE,yBAAA;EACA,YAAA;AAPF;;AASA;EACE,8BAAA;AANF;;AAQA;EACA,8BAAA;AALA;;AAOA;EACA,yBAAA;EACE,YAAA;AAJF;;AAOA;EACE,8BAAA;AAJF;;AAMA;EACE,8BAAA;AAHF;;AAMA;EACA,wDAAA;AAHA;;AAMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;AAHF;;AAMA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;AAHF;;AAKA;EACE,eAAA;EACA,eAAA;EACA,eAAA;AAFF;;AAKA;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;AAFF;AAGE;EACE,2BAAA;AADJ;;AAIA;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;AADF;AAEE;EACE,2BAAA;AAAJ;;AAIA;EACE,2BAAA;EACA,6BAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AADF;;AAIA;EACE,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,oCAAA;EAEA,wCAAA;EACA,yDAAA;EACA,wDAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAMA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAHF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;AAFF;;AA6FA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AA1FF;;AA4FA;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACE,iCAAA;AAzFJ;;AA4FA;EACE,cAAA;EACA,uBAAA;AAzFF;;AA2FA;EACE,kCAAA;AAxFF;;AA2FA;EACE,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kCAAA;AAxFF;;AA0FA;EACE,8BAAA;AAvFF;;AA0FA;EACE,+BAAA;AAvFF;;AAyFA;EACE,YAAA;EACA,iCAAA;EACA,kBAAA;AAtFF;;AAwFA;EACE,4BAAA;AArFF;;AAoGA;;;;;;;;CAAA;AA0DA;EACE,yBAAA;AAlJF;;AAqJA;EACE,8DAAA;AAlJF;;AAsJA;EAEE,kBAAA;EACA,SAAA;EACA,WAAA;AApJF;;AAuJA;EACE,yBAAA;EACA,2BAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;AApJF;;AAsJA;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;AAnJF;AAoJE;EACE,2BAAA;AAlJJ;;AAyJA;EACE,yBAAA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAtJJ;;AAwJA;EACE,yBAAA;EACA,YAAA;EACA,oBAAA,EAAA,0BAAA;EACA,mBAAA,EAAA,uBAAA,EAAA,oCAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AArJF;;AAwJA;EACE,yBAAA;AArJF;;AAwJA;EACE,eAAA;EAAiB,kBAAA;EAAkB,SAAA;EAAW,iBAAA;EAAmB,wBAAA,EAAA,4BAAA;AAjJnE;;AAmJA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAhJF;;AAkJA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AA/IF;;AAiJA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AA9IF;;AAgJA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AA7IF;;AA+IA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AA5IF;;AA8IA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AA3IF;;AA6IA;EACE,uBAAA;EACA,eAAA;AA1IF;AA2IE;EACE,2BAAA;AAzIJ","sourcesContent":["@import \"../../../variables.scss\";\r\n@import 'src/assets/fonts/Nunito/Nunito.css';\r\n\r\n.Case_360_view {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.eventselecttypeControl {\r\n  width: 96%;\r\n  border: none;\r\n  padding-block: 2px;\r\n  height: 28px;\r\n  margin-left: 2%;\r\n  padding-right: 23px !important;\r\n}\r\n.blod_text {\r\n  color: #007887;\r\n}\r\n.date_control_style {\r\n  width: 30%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%),\r\n    0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 2%;\r\n}\r\n.close_icon {\r\n  position: absolute;\r\n  top: 27%;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  color: grey;\r\n  font-weight: 600;\r\n  right: 0;\r\n}\r\n.help-main-title {\r\n  font-size: 17px;\r\n  text-align: center;\r\n}\r\n.case_details {\r\n  flex: auto;\r\n  text-align: center;\r\n  position: relative;\r\n  //   width: 14.28%;\r\n  // float: left;\r\n}\r\n.caseHeaderBorder {\r\n  height: 14px;\r\n  width: 2px;\r\n  background-color: #17a0b4 !important;\r\n  position: absolute;\r\n  top: 14%;\r\n  right: 0%;\r\n}\r\n.case_info {\r\n  background: #e2e2e2 0% 0% no-repeat padding-box;\r\n  padding-inline: 8px;\r\n  // border-radius: 5px;\r\n}\r\n.messageList_view{\r\n  height: 66vh;overflow-x: hidden;\r\n  font-size: 11px;\r\n}\r\n::ng-deep.message_screen_case {\r\n  font-family: montserrat !important;\r\n  // height: 73vh;\r\n  overflow: hidden;\r\n  .mat-tab-header {\r\n    height: 29;\r\n  }\r\n  .mat-tab-label {\r\n    height: 31px !important;\r\n    text-transform: uppercase;\r\n  }\r\n  .mat-tab-group.mat-primary .mat-ink-bar,\r\n  .mat-tab-nav-bar.mat-primary .mat-ink-bar {\r\n    // background-color: #f77a99 !important;\r\n    // left: 12px !important;\r\n    margin-left: unset !important;\r\n  }\r\n\r\n  .mat-tab-label-container {\r\n    background-color: transparent;\r\n    border-bottom: 1px solid #17a0b4;\r\n  }\r\n  .mat-tab-group.mat-primary .mat-ink-bar {\r\n    background-color: #376B96 !important;\r\n    height: 2px !important;\r\n  }\r\n  .mat-tab-label .mat-tab-label-content {\r\n    font-size: 11px !important;\r\n    font-weight: 600 !important;\r\n    font-family: montserrat !important;\r\n  }\r\n\r\n  .mat-tab-label.mat-ripple.mat-tab-label-active {\r\n    color: #376B96 !important;\r\n    background-color: white !important;\r\n    opacity: unset !important;\r\n  }\r\n}\r\n\r\n.active_img {\r\n  display: none;\r\n}\r\n.inactive_img {\r\n  display: block;\r\n  margin-right: 9px;\r\n  position: relative;\r\n  top: -2px;\r\n}\r\n.active_img_inbound {\r\n  display: none;\r\n}\r\n.inactive_img_inbound {\r\n  display: block;\r\n  margin-right: 11px;\r\n  position: relative;\r\n  top: -2px;\r\n}\r\n::ng-deep.event_card {\r\n  height: 73vh;\r\n  border-right: 3px solid #007887;\r\n  .header {\r\n    height: 40px;\r\n    background: #f2f2f2 0% 0% no-repeat padding-box;\r\n    .search_control {\r\n      width: 90%;\r\n      height: 25px;\r\n      margin: auto;\r\n      border-radius: 5px;\r\n      border: 1px solid #001c3b;\r\n      background-color: white;\r\n      .search_icon {\r\n        position: relative;\r\n        left: 2%;\r\n        top: 10%;\r\n      }\r\n      .input_control {\r\n        width: 93%;\r\n        border: none;\r\n        background-color: transparent;\r\n        position: relative;\r\n        left: 3%;\r\n        top: 13%;\r\n      }\r\n    }\r\n  }\r\n\r\n  .mat-tab-label {\r\n    height: 29px !important;\r\n    flex: 1 !important;\r\n    text-transform: uppercase;\r\n  }\r\n  .mat-tab-group.mat-primary .mat-ink-bar,\r\n  .mat-tab-nav-bar.mat-primary .mat-ink-bar {\r\n    // background-color: #f77a99 !important;\r\n    // left: 12px !important;\r\n    margin-left: unset !important;\r\n  }\r\n\r\n  .mat-tab-label-container {\r\n    background-color: #f3f3f3 !important;\r\n  }\r\n  .mat-tab-group.mat-primary .mat-ink-bar {\r\n    background-color: #376B96 !important;\r\n    height: 3px !important;\r\n  }\r\n  .mat-tab-label .mat-tab-label-content {\r\n    font-size: 10px !important;\r\n    font-weight: 600 !important;\r\n    font-family: montserrat !important;\r\n  }\r\n\r\n  .mat-tab-label.mat-ripple.mat-tab-label-active {\r\n    color: #376B96 !important;\r\n    background-color: white !important;\r\n    opacity: unset !important;\r\n    .outbound_style {\r\n      .active_img {\r\n        display: block !important;\r\n        margin-right: 9px;\r\n        position: relative;\r\n        top: -2px;\r\n      }\r\n      .inactive_img {\r\n        display: none !important;\r\n      }\r\n    }\r\n    .inbound_style {\r\n      .active_img_inbound {\r\n        display: block !important;\r\n        margin-right: 11px;\r\n        position: relative;\r\n        top: -2px;\r\n      }\r\n      .inactive_img_inbound {\r\n        display: none !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n.event_card_info {\r\n  height: 73vh;\r\n  border-left: 3px solid #007887;\r\n  margin-left: 2px;\r\n  .header {\r\n    height: 40px;\r\n    background: #f2f2f2 0% 0% no-repeat padding-box;\r\n  }\r\n}\r\n.Event_lables {\r\n  max-height: 60px;\r\n  background: #e5f1f3;\r\n  padding-inline: 13px;\r\n  overflow-x: hidden;\r\n  min-height: 33px;\r\n  font-family: montserrat !important;\r\n}\r\n.eventtype_lables {\r\n  background-color: white;\r\n  padding-inline: 4%;\r\n  padding-block: 0px;\r\n  margin: 6px;\r\n  display: inline-block;\r\n  border-radius: 50pc;\r\n  cursor: pointer;\r\n  box-shadow: 1px 1px 4px 0px grey;\r\n  font-size: 11px;\r\n}\r\n\r\n.eventtype_lables_active {\r\n  background-color: #007887;\r\n  padding-inline: 4%;\r\n  padding-block: 0px;\r\n  margin: 6px;\r\n  display: inline-block;\r\n  border-radius: 50pc;\r\n  cursor: pointer;\r\n  color: white;\r\n  box-shadow: 1px 1px 4px 0px grey;\r\n  font-size: 11px;\r\n}\r\n// @font-face {\r\n//   font-family: 'inoubd';\r\n//   src: url('a1xex-u3e2x.ttf');\r\n// }\r\n\r\n// .usefont{\r\n//   font-family: 'inoubd', sans-serif;\r\n// }\r\n\r\n.messageInfo {\r\n  // border-left: 4px solid green;\r\n  box-shadow: 1px 1px 6px 0px grey;\r\n  border-radius: 5px;\r\n  padding-inline: 6px;\r\n  padding-block: 3px;\r\n}\r\n\r\n.cardActive {\r\n  background-color: #cce4e7;\r\n}\r\n\r\n.listview {\r\n  padding-inline: 19px;\r\n  max-height: 53vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  font-family: montserrat !important;\r\n  font-size: 11px;\r\n}\r\n\r\n.view_file_icon {\r\n  width: 19px !important;\r\n  // float: left;\r\n  position: relative;\r\n  top: 6px;\r\n  left: 6px;\r\n}\r\n\r\n.barline {\r\n  height: 1px;\r\n  background-color: black;\r\n  margin-inline: 13px;\r\n}\r\n\r\n::ng-deep.message_menu.mat-menu-panel {\r\n  button.mat-menu-item {\r\n    height: 26px !important;\r\n    line-height: 26px !important;\r\n    text-align: center !important;\r\n    color: #179fb3 !important;\r\n    font-size: 13px !important;\r\n  }\r\n}\r\n\r\n.lables_status {\r\n  border-radius: 4px;\r\n  padding-block: 3px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n}\r\n\r\n::ng-deep.viewstages .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.viewstages {\r\n  top: 4% !important;\r\n}\r\n\r\n.inputContainer {\r\n  height: 60vh;\r\n  background-color: #f3f3f3;\r\n  border: 1px solid #707070;\r\n  .header {\r\n    background-color: #d1d1d1;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    border-bottom: 1px solid #707070;\r\n  }\r\n}\r\n.outputContainer {\r\n  height: 60vh;\r\n  background-color: #f3f3f3;\r\n  border: 1px solid #707070;\r\n  .header {\r\n    background-color: #d1d1d1;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    border-bottom: 1px solid #707070;\r\n  }\r\n}\r\n\r\n.icons_list_style {\r\n  width: 5%;\r\n  padding-bottom: 1px;\r\n  text-align: center;\r\n  margin-inline: 3px;\r\n  height: 35px;\r\n}\r\n.icons_list_style_active {\r\n  border-bottom: 3px solid #00bcd4;\r\n  width: 5%;\r\n  padding-bottom: 1px;\r\n  text-align: center;\r\n  margin-inline: 3px;\r\n  height: 35px;\r\n  position: relative;\r\n}\r\n\r\n.case_info_container {\r\n  border: 1.5px solid #17a0b4;\r\n  padding: 5px;\r\n  position: relative;\r\n  margin-block: 16px;\r\n}\r\n\r\n.card_label_title {\r\n  background-color: #fbfbfb;\r\n  position: absolute;\r\n  padding-inline: 5px;\r\n  font-size: 11px;\r\n  top: -10px;\r\n  color: #17a0b4;\r\n  font-weight: 600;\r\n}\r\n\r\n.active_card {\r\n  background-color: #07a36e;\r\n  color: white;\r\n}\r\n.created_card {\r\n  background-color: #ffc107;\r\n  color: white;\r\n}\r\n\r\n.failed_card {\r\n  background-color: #da606c;\r\n  color: white;\r\n}\r\n.healing_card {\r\n  background-color: #f5a700;\r\n  color: white;\r\n}\r\n\r\n.ignore_card {\r\n  background-color: #808080b0;\r\n  color: rgba(8, 8, 8, 0.897);\r\n  }\r\n\r\n.active_card_bor {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n.created_card_bor {\r\n  border-left: 4px solid #ffc107;\r\n}\r\n.inprogress_card{\r\n  background-color: #ff8900;\r\n  color: white;\r\n}\r\n.inprogress_card_bor{\r\n  border-left: 4px solid #ff8900;\r\n}\r\n.hold_card_bor{\r\nborder-left: 4px solid #007bff;\r\n}\r\n.hold_card{\r\nbackground-color: #007bff;\r\n  color: white;\r\n}\r\n\r\n.failed_card_bor {\r\n  border-left: 4px solid #da606c;\r\n}\r\n.healing_card_bor {\r\n  border-left: 4px solid #f5a700;\r\n}\r\n\r\n.ignore_card_bor {\r\nborder-left: 4px solid #808080b0;\r\n}\r\n\r\n.input_data_control {\r\n  width: 100%;\r\n  height: 54vh;\r\n  overflow-x: hidden;\r\n  padding-inline: 12px;\r\n  padding-block: 3px;\r\n  word-break: break-word;\r\n}\r\n\r\n.acknowledge {\r\n  font-size: 25px;\r\n  position: relative;\r\n  top: -1px;\r\n}\r\n\r\n.transform {\r\n  font-size: 27px;\r\n  position: relative;\r\n  top: -5px;\r\n}\r\n.copy_icon {\r\n  margin-left: 2%;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n}\r\n\r\n::ng-deep.viewstages {\r\n  top: 4% !important;\r\n  font-family: montserrat;\r\n  font-size: 11px;\r\n  strong{\r\n    font-weight: 600 !important;\r\n  }\r\n}\r\n::ng-deep.viewfiles {\r\n  top: 4% !important;\r\n  font-family: montserrat;\r\n  font-size: 11px;\r\n  strong{\r\n    font-weight: 600 !important;\r\n  }\r\n}\r\n\r\n::ng-deep.messageioteditor .editor-container {\r\n  overflow: hidden !important;\r\n  position: relative !important;\r\n  display: table !important;\r\n  width: 100% !important;\r\n  height: 99% !important;\r\n  min-width: 0 !important;\r\n}\r\n\r\n::ng-deep.messageiot .modal-dialog .modal-content .modal-footer {\r\n  display: unset !important;\r\n  flex-wrap: wrap !important;\r\n  align-items: center !important;\r\n  justify-content: flex-end !important;\r\n\r\n  border-top: 1px solid #dee2e6 !important;\r\n  border-bottom-right-radius: calc(0.3rem - 1px) !important;\r\n  border-bottom-left-radius: calc(0.3rem - 1px) !important;\r\n}\r\n\r\n.stages_cards {\r\n  height: 80vh;\r\n}\r\n\r\n\r\n::ng-deep.viewfiles .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.viewfiles {\r\n  top: 4% !important;\r\n}\r\n\r\n.text_elip{\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow-x: hidden;\r\n}\r\n\r\n\r\n// // tables\r\n\r\n// .example-container {\r\n//   height: 400px;\r\n//   overflow: auto;\r\n// }\r\n\r\n// .mat-mdc-table-sticky {\r\n//   background: #59abfd;\r\n//   opacity: 1;\r\n// }\r\n\r\n// .example-sticky-toggle-group {\r\n//   margin: 8px;\r\n// }\r\n\r\n// .mat-column-filler {\r\n//   padding: 0 8px;\r\n//   font-size: 10px;\r\n//   text-align: center;\r\n// }\r\n\r\n// .mat-mdc-header-cell, .mat-mdc-footer-cell, .mat-mdc-cell {\r\n//   min-width: 80px;\r\n//   box-sizing: border-box;\r\n// }\r\n\r\n// .mat-mdc-header-row, .mat-mdc-footer-row, .mat-mdc-row {\r\n//   min-width: 1920px; __<<ngThemingMigrationEscapedComment0>>__\r\n// }\r\n\r\n// .mat-mdc-table-sticky-border-elem-top {\r\n//   border-bottom: 2px solid midnightblue;\r\n// }\r\n\r\n// .mat-mdc-table-sticky-border-elem-right {\r\n//   border-left: 2px solid midnightblue;\r\n// }\r\n\r\n// .mat-mdc-table-sticky-border-elem-bottom {\r\n//   border-top: 2px solid midnightblue;\r\n// }\r\n\r\n// .mat-mdc-table-sticky-border-elem-left {\r\n//   border-right: 2px solid midnightblue;\r\n// }\r\n\r\n\r\n\r\n// .example-container {\r\n//   height: 400px;\r\n//   width: 550px;\r\n//   max-width: 100%;\r\n//   overflow: auto;\r\n// }\r\n\r\n// table {\r\n//   width: 800px;\r\n// }\r\n\r\n// td.mat-column-star {\r\n//   width: 20px;\r\n//   padding-right: 8px;\r\n// }\r\n\r\n// th.mat-column-position, td.mat-column-position {\r\n//   padding-left: 8px;\r\n// }\r\n\r\n// .mat-table-sticky-border-elem-right {\r\n//   border-left: 1px solid #e0e0e0;\r\n// }\r\n\r\n// .mat-table-sticky-border-elem-left {\r\n//   border-right: 1px solid #e0e0e0;\r\n// }\r\n\r\n// .example-container {\r\n//   height: 328px;\r\n//   overflow: auto;\r\n//   display: flex;\r\n//   align-items: center;\r\n//   width: 89%;\r\n//   margin: auto;\r\n//   position: relative !important;\r\n// }\r\n\r\n.example-container {\r\n  height: 200px;\r\n  min-height: 550px;\r\n  overflow: auto;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: auto;\r\n}\r\n.app-table-wrapper {\r\n  overflow-x: scroll;\r\n  font-family: montserrat ;\r\n  margin: 20px;\r\n    box-shadow: 0px 0px 5px -1px grey;\r\n}\r\n\r\n.app-table {\r\n  font-size: 8px;\r\n  font-family: montserrat ;\r\n}\r\n#app-table{\r\n  font-family: montserrat !important ;\r\n}\r\n\r\n.mat-cell {\r\n  padding: 6px;\r\n  border-right: 1px solid lightgrey;\r\n  text-align: center;\r\n  min-width: 100px;\r\n  font-size: 12px;\r\n  background-color: white !important;\r\n}\r\n.mat-table-sticky-border-elem-right {\r\n  border-left: 1px solid #e0e0e0;\r\n}\r\n\r\n.mat-table-sticky-border-elem-left {\r\n  border-right: 1px solid #e0e0e0;\r\n}\r\n.mat-header-cell {\r\n  padding: 2px;\r\n  border-right: 1px solid lightgrey;\r\n  text-align: center;\r\n}\r\ntd.mat-cell:first-of-type{\r\n  padding-left:0px !important;\r\n}\r\n// table {\r\n//   width: 800px;\r\n// }\r\n\r\n// td.mat-column-star {\r\n//   width: 20px;\r\n//   padding-right: 8px;\r\n// }\r\n\r\n// .mat-table-sticky:last-child {\r\n//   border-left: 1px solid #e0e0e0;\r\n// }\r\n\r\n/*\r\n.mat-column-name {\r\n  width: 110px;\r\n}\r\n.mat-column-position {\r\n  width: 80px;\r\n  left: 110px !important;\r\n}\r\n*/\r\n// .mat-cell, .mat-header-cell {\r\n//   padding-left:8px;\r\n//   padding-right:8px;\r\n// }\r\n\r\n// .mat-column-position {\r\n//   border-right: 1px solid #e0e0e0;\r\n// }\r\n\r\n// table {\r\n//   width: 100%;\r\n// }\r\n// tr{\r\n//   display: flex;\r\n// }\r\n\r\n// th.mat-header-cell{\r\n//   top: 0px;\r\n//   z-index: 101;\r\n//   left: 0px;\r\n//   position: sticky;\r\n//   min-width: 97px;\r\n//   padding-inline: 16px;\r\n// }\r\n// td.mat-cell{\r\n//   left: 0px;\r\n//   position: sticky;\r\n//   z-index: 1;\r\n//   min-width: 97px;\r\n//   text-align: center;\r\n//   padding-top: 7px;\r\n// }\r\n\r\n// .mat-col-name {\r\n//   width: 100px !important;\r\n//   top: 56px;\r\n//   z-index: 101;\r\n//   left: 0px;\r\n//   position: sticky;\r\n// }\r\n\r\n// .mat-col-address {\r\n//   left: 100px !important;\r\n//   width: 100px;\r\n//   top: 56px;\r\n//   z-index: 101;\r\n//   position: sticky;\r\n// }\r\n\r\n.text_green{\r\n  color: #30cd30 !important;\r\n}\r\n\r\n.mismatch{\r\n  background-color: #ffb6b68c !important;\r\n    // border: 2px solid #f4445575;\r\n}\r\n\r\n.view-btn-details\r\n{\r\n  position: absolute;\r\n  left: 57%;\r\n  width: 84px;\r\n}\r\n\r\n::ng-deep.Mode_Boot .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 100% !important;\r\n  height: 100% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.Mode_Boot {\r\n  top: 3% !important;\r\n  font-family: montserrat;\r\n  font-size: 12px;\r\n  strong{\r\n    font-weight: 600 !important;\r\n  }\r\n}\r\n\r\n.interfacehvr{\r\n\r\n}\r\n.interfacehvr:hover{\r\n  background-color: #3fa4fb;\r\n    border-radius: 12px;\r\n    color: white;\r\n    padding: 3px;\r\n    cursor: pointer;\r\n}\r\n.hl7-btn {\r\n  background-color: #17a0b4;\r\n  color: white;\r\n  display: inline-flex;        /* flexbox for alignment */\r\n  align-items: center;         /* vertical centering */                             /* adjust padding for compact size */\r\n  cursor: pointer;\r\n  width: 90px;\r\n  height: 24px\r\n}\r\n\r\n.hl7-btn:hover {\r\n  background-color: #138b9a;\r\n}\r\n\r\n.hl7-icon {\r\n  font-size: 18px; position:relative;left: 2px; margin-right: 4px; padding: 3px 8px 6px 3px;    /* size balanced with text */\r\n}\r\n.copylabel {\r\n  font-size: 14px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n}\r\n::ng-deep.messageiotcase360 .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.viewstagescasemsg360 .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.Mode_Bootcase360 .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.myCustomModalClasscase360 .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.myCustomModalClasscase360hl7 .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.messageiotcase360 {\r\n  font-family: montserrat;\r\n  font-size: 11px;\r\n  strong{\r\n    font-weight: 600 !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
